import React, { useEffect, useState } from "react";
import { Play, Pause, Calendar, Clock } from "lucide-react";

const TimelineBar = ({
  minDate,
  maxDate,
  currentDate,
  onChange,
  playing,
  onPlayToggle,
  speed,
  onSpeedChange,
}) => {
  const [dateList, setDateList] = useState([]);

  useEffect(() => {
    if (minDate && maxDate) {
      const dates = [];
      let cur = new Date(minDate);
      const end = new Date(maxDate);
      while (cur <= end) {
        dates.push(cur.toISOString().split("T")[0]);
        cur.setDate(cur.getDate() + 1);
      }
      setDateList(dates);
    }
  }, [minDate, maxDate]);

  return (
    <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex items-center gap-3 px-5 py-2.5 bg-black/70 backdrop-blur-md border border-cyan-500/30 rounded-full shadow-2xl text-white select-none transition-all hover:bg-black/80 animate-in fade-in slide-in-from-bottom-4">
      
      {/* Play/Pause Group */}
      <div className="flex items-center gap-2">
          <button
            onClick={onPlayToggle}
            className="flex items-center justify-center w-8 h-8 rounded-full bg-cyan-600 hover:bg-cyan-500 text-white shadow-[0_0_10px_rgba(8,145,178,0.5)] transition-all active:scale-95"
            title={playing ? "일시정지" : "재생"}
          >
            {playing ? <Pause fill="white" size={14} /> : <Play fill="white" className="ml-0.5" size={14} />}
          </button>
          
          {/* Speed Select */}
          <select
            value={speed}
            onChange={(e) => onSpeedChange(Number(e.target.value))}
            className="bg-transparent text-xs font-medium text-gray-400 focus:outline-none cursor-pointer hover:text-cyan-300 w-12 text-right appearance-none"
            title="재생 속도"
          >
            <option value={0.25} className="bg-gray-900">x 0.25</option>
            <option value={0.5} className="bg-gray-900">x 0.5</option>
            <option value={1} className="bg-gray-900">x 1.0</option>
            <option value={2} className="bg-gray-900">x 2.0</option>
            <option value={4} className="bg-gray-900">x 4.0</option>
          </select>
      </div>

      <div className="h-6 w-px bg-gray-700/50" />

      {/* Slider Area */}
      <div className="flex flex-col justify-center w-[240px]">
        <input
          type="range"
          min={0}
          max={dateList.length - 1}
          value={dateList.indexOf(currentDate)}
          onChange={(e) => onChange(dateList[e.target.value])}
          className="w-full h-1 bg-gray-600 rounded-lg appearance-none cursor-pointer accent-cyan-500 hover:accent-cyan-400"
        />
        <div className="flex justify-between text-[9px] text-gray-500 font-mono mt-1">
            <span>{minDate}</span>
            <span>{maxDate}</span>
        </div>
      </div>

      <div className="h-6 w-px bg-gray-700/50" />

      {/* Current Date Display */}
      <div className="flex items-center gap-2 pl-1">
          <Calendar size={14} className="text-cyan-500" />
          <span className="font-mono text-sm font-bold text-white tracking-wider">{currentDate}</span>
      </div>
    
    </div>
  );
};

export default TimelineBar;
